import React, { createContext, useEffect, useMemo, useState } from 'react';

export const GeoLocationContext = createContext(null);

export const GeoLocationProvider = ({ children, ssrLocation = '' }) => {
  const [location, setLocation] = useState(ssrLocation || '');
  const [phoneNumber] = useState('+123456789');

  useEffect(() => {
    setLocation(ssrLocation || '');
  }, [ssrLocation]);

  const updateLocation = (locationValue) => {
    setLocation(typeof locationValue === 'string' ? locationValue : '');
  };

  const value = useMemo(() => ({ location, updateLocation, phoneNumber }), [location, phoneNumber]);

  return <GeoLocationContext.Provider value={value}>{children}</GeoLocationContext.Provider>;
};
